import { useContext } from 'react';
import { ValidationContext, ValidationContextProps } from 'src/providers/ValidationContextProvider';
import { ValidationNames } from 'src/utils/Constants';

export function useValidationContext(): ValidationContextProps {
  return useContext(ValidationContext);
}

export function useIsPdfOnly(): boolean {
  const { validations, validationPlaceholders } = useValidationContext();

  const validationsToUse = validations ?? validationPlaceholders;
  const validationToUse = validationsToUse?.find(validation => validation.id === ValidationNames.CorruptValidator);
  return validationToUse && validationToUse?.details && (validationToUse?.details['pdfOnly'] ?? false);
}
